/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button, Sidebar } from "@nordcloud/gnui";
import { useQueryState } from "~/tools";
import { Filters } from "./Filters";
import { FiltersProp } from "./types";

type QueryState = FiltersProp & {
  page: number;
  limit: number;
};

export function FiltersToggle() {
  const [isOpen, setIsOpen] = React.useState(false);
  const [state] = useQueryState();

  const {
    limit: ignoredLimit,
    page: ignoredPage,
    ...restFilters
  }: QueryState = state;

  const [filters, setFilters] = React.useState<FiltersProp>(restFilters);
  const toggleFilters = (openFilters: boolean) => {
    setFilters(restFilters);
    setIsOpen(openFilters);
  };

  return (
    <>
      <Button
        severity="low"
        icon="filter"
        css={{ marginLeft: "1rem" }}
        onClick={() => toggleFilters(true)}
      >
        Filters
      </Button>
      <Sidebar
        title="Filter Results"
        isOpen={isOpen}
        onClick={() => toggleFilters(false)}
      >
        <Filters
          onClose={() => toggleFilters(false)}
          filters={filters}
          setFilters={setFilters}
        />
      </Sidebar>
    </>
  );
}
